













import Vue from "vue";
import Component from "vue-class-component";
import Hero from "@/components/home/Hero.vue";
import UnitSummary from "@/components/home/UnitSummary.vue";
import NextEvent from "@/components/home/NextEvent.vue";
import UnitStats from "@/components/home/UnitStats.vue";
import Moodboard from "@/components/home/Moodboard.vue";

@Component({
  components: { Hero, UnitSummary, NextEvent, UnitStats, Moodboard },
})
export default class Home extends Vue {}
